import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxCarouselModule } from 'ngx-carousel';
import 'hammerjs';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import { HttpModule } from '@angular/http';
import {NgxPaginationModule} from 'ngx-pagination';

//import component
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { AccordionToggleComponent } from './accordion-toggle/accordion-toggle.component';
import { CustomersSliderComponent } from './customers-slider/customers-slider.component';
import { FooterComponent } from './footer/footer.component';
import { LoginComponent } from './login/login.component';
import { PriceComponent } from './price/price.component';
import { routing } from './app.routes';
import { HomeComponent } from './home/home.component';
import { PlaceHolderComponent } from './place-holder/place-holder.component';
import { PaymentComponent } from './payment/payment.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { ViewProfileComponent } from './view-profile/view-profile.component';
import { MyPaymentComponent } from './my-payment/my-payment.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

import { MyOrderComponent } from './my-order/my-order.component';


import { ModalComponent } from './modal/modal.component';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';

//import services
import { AuthService } from './providers/auth.service';

//imports guards
import { AuthGuard } from './auth/auth.guard';
import { VerificationComponent } from './verification/verification.component';
import { EqualValidatorDirective } from './directive/equal-validator.directive';
import { OnlyNumber } from './directive/onlynumber.directive';
import { DriverResetPasswordComponent } from './driver-reset-password/driver-reset-password.component';


import { Ng4GeoautocompleteModule } from 'ng4-geoautocomplete';
import { SignupComponent } from './signup/signup.component';
import { UpdateCardComponent } from './update-card/update-card.component';


@NgModule({
  declarations: [
    AppComponent, 
	HeaderComponent, AccordionToggleComponent, CustomersSliderComponent, FooterComponent, LoginComponent, PriceComponent, HomeComponent, PlaceHolderComponent, PaymentComponent, AboutComponent, ContactComponent, NotFoundComponent, ModalComponent, VerificationComponent, EqualValidatorDirective, OnlyNumber, ChangePasswordComponent, EditProfileComponent, ViewProfileComponent, MyPaymentComponent, ForgotPasswordComponent, MyOrderComponent, ResetPasswordComponent, DriverResetPasswordComponent, SignupComponent, UpdateCardComponent
  ],
  imports: [
    BrowserModule,
    NgxCarouselModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule.forRoot(),
    routing,
    HttpModule,
    Ng4LoadingSpinnerModule.forRoot(),
    Ng4GeoautocompleteModule.forRoot(),
    NgxPaginationModule
  ],
  providers: [AuthService, AuthGuard],
  bootstrap: [AppComponent],
  entryComponents: [
    ModalComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/app.module.ts